/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2024, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { Tabs, Tab } from 'carbon-components-react';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import { SearchResultDialogs } from '../../discovery/components/search-detail-config/search-result-dialogs/SearchResultDialogs';
import { ConfigureContent } from './ConfigureContent';
import { MilvusTabsMessages as messages } from './messages';
import { MilvusDataSource } from './MilvusDataSource';
import { MilvusInstanceConfig } from './MilvusInstanceConfig';
import '../../elastic-search/components/ElasticSearchTabs.scss';

interface MilvusTabProps {
  readOnly: boolean;
  draft: {
    noResultsMessage: string;
    setNoResultsMessage: (string) => void;
    connectivityMessage: string;
    setConnectivityMessage: (string) => void;
  };
  onClose: () => void;
  updateConfig: () => void;
  assistantId: string;
  skillId: string;
}

export const MilvusTabs = ({
  readOnly,
  draft,
  skillId,
  assistantId,
  onClose,
  updateConfig
}: MilvusTabProps) => {
  const { formatMessage: t } = useIntl();
  const [tabIndex, setTabIndex] = useState(0);
  const handleTabChange = selectedIndex => {
    setTabIndex(selectedIndex);
  };

  return (
    <div className="CustomServiceSearch">
      <div className="CustomServiceSearch__container">
        <Tabs
          type="container"
          light
          selected={tabIndex}
          onSelectionChange={handleTabChange}>
          <Tab
            id="CustomServiceSearchTabs-settings"
            label={t(messages.settings)}>
            <div className="CustomServiceSearch__settings">
              <div className="CustomServiceSearch__settings-container">
                <MilvusDataSource
                  showTab={true}
                  skillId={skillId}
                  assistantId={assistantId}
                  readOnly={readOnly}
                />
                <ConfigureContent tabDisplay={true} readOnly={readOnly} />
                <SearchResultDialogs
                  hideSuccessMessageTab={true}
                  noResultsMessage={draft.noResultsMessage}
                  setNoResultsMessage={draft.setNoResultsMessage}
                  connectivityMessage={draft.connectivityMessage}
                  setConnectivityMessage={draft.setConnectivityMessage}
                />
              </div>
            </div>
          </Tab>
          <Tab
            className="CustomServiceSearchTabs-tab"
            id="CustomServiceSearchTabs-instanced"
            label={t(messages.instance)}>
            <MilvusInstanceConfig
              noHeader={true}
              readOnly={readOnly}
              onClose={onClose}
              updateConfig={updateConfig}
            />
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};
